import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import ContentPost from "@/pages/ContentPost";
const ContentPostRoute = () => <ContentPost contentType="case_studies" />;

export const Route = createFileRoute("/es/casos-de-exito/$slug")({
  loader: ({ params }) => loadContentMeta("case_studies", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/casos-de-exito/${params.slug}`, loaderData),
  component: ContentPostRoute,
});

